import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import { useMyCapabilities } from '@/hooks/use-permissions';
import { isInternalRole } from '@/types';

interface InternalRouteProps {
  children: React.ReactNode;
  /** If set, user must also have at least one of these capabilities. */
  anyOfCapabilities?: string[];
}

/**
 * Route guard for internal roles (admin, supervisor, user).
 * Excludes clients. Optionally enforces capability checks.
 */
export function InternalRoute({ children, anyOfCapabilities }: InternalRouteProps) {
  const { user, isLoading } = useAuth();
  const { data: capabilities, isLoading: capsLoading } = useMyCapabilities();

  if (isLoading || (anyOfCapabilities?.length && capsLoading)) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user || !isInternalRole(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (anyOfCapabilities?.length && capabilities) {
    const hasAny = anyOfCapabilities.some((key) => capabilities[key]);
    if (!hasAny) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <>{children}</>;
}
